import classNames from "classnames";
import CardTitle from "../../../components/CardTitle";
import TMapComp from "../../../components/TMap";
import styles from "./WisdomPartyBuilding.module.scss";
import YearPicker from "../../../components/YearPicker";
import styled from "@emotion/styled";
import valueBoxImg from "../../../images/value-box.png";
import { Area } from "@ant-design/plots";
import lineBox2Img from "../../../images/line-box2.png";
import { MainLayout } from "../../../components/Layout";
import { LiveTime } from "../../../components/LiveTime/index";
import { useCallback, useEffect, useRef, useState } from "react";
import request from "../../../utils/request";
import EchartSingleLine from "../components/Charts/SingleLine";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
const EnergyConsumptionAnalysisLayout = styled.div`
  .left {
    width: 495px !important;
    padding-left: 10px !important;
  }
  .warn-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .warn-val {
      line-height: 76px;
      text-align: center;
      width: 62px;
      height: 76px;
      background-image: url(${valueBoxImg});
      font-size: 46px;
      font-weight: 400;
      color: #ffff01;
    }
    p {
      color: #fff;
      font-size: 20px;
      margin-top: 12px;
    }
  }
  .area-chart-common {
    margin-top: 57px;
  }
  .area-chart {
    margin-top: 40px;
    padding: 0 40px 0 53px;
  }
  .points {
    color: #fff;
    font-size: 14px;
    justify-content: center;
    margin-top: 30px;
    .point-item {
      align-items: center;
      &:first-child {
        margin-right: 55px;
      }
    }
    .point {
      width: 28px;
      height: 14px;
      margin-left: 10px;
      &.electricity {
        background-color: #2f5097;
      }
      &.water {
        background-color: #41ff5c;
      }
    }
  }
  .energy {
    padding-right: 20px;
    margin-top: 24px;
    margin-left: 15px;
    li {
      height: 35px;
      display: flex;
      background-image: url(${lineBox2Img});
      background-repeat: no-repeat;
      color: #1cfbff;
      align-items: center;
      /* padding-right: 30px;
      padding-left: 30px; */
      padding: 18px;
      width: 100%;
      .point-box {
        display: flex;
        align-items: center;
        .point {
          height: 13px;
        }
        .electricity {
          background-color: #2f5097;
        }
        .water {
          background-color: #41ff5c;
        }
      }
    }
  }
  .swiper-slide {
    display: inherit !important;
  }
`;

const EnergyConsumptionAnalysis: React.FC = () => {
  const config: React.ComponentProps<typeof Area> = {
    smooth: true,
    height: 200,
    data: [
      {
        year: 2019,
        value: 60,
      },
      {
        year: 2020,
        value: 100,
      },
      {
        year: 2021,
        value: 30,
      },
      {
        year: 2022,
        value: 180,
      },
      {
        year: 2023,
        value: 70,
      },
    ],
    xField: "year",
    yField: "value",
    xAxis: {
      range: [0, 1],
    },
  };

  const [currentYearShui, setCurrentYearShui] = useState<[string, string]>([
    "2020",
    "2023",
  ]);
  const [currentYearDian, setCurrentYearDian] = useState<[string, string]>([
    "2020",
    "2023",
  ]);
  const [list, setList] = useState([]);
  const [shui, setShui] = useState([]);
  const [dian, setDian] = useState([]);
  const getDataShui = async () => {
    try {
      //  https://apiv2.wxstores.cn/screen/Other/getEnergyWaterData?years=2020-2022&type=1
      const res = await request.get(
        "/screen/Other/getEnergyWaterData?years=" +
          currentYearShui.join("-") +
          "&type=0"
      );
      const data = res.data.data;
      setShui(
        data.categories.map((year: string, index: number) => {
          return {
            year: year,
            value: data.line[index],
          };
        })
      );
    } catch (e) {}
  };
  const getDataDian = async () => {
    try {
      const res = await request.get(
        "/screen/Other/getEnergyWaterData?years=" +
          currentYearDian.join("-") +
          "&type=1"
      );
      const data = res.data.data;
      setDian(
        data.categories.map((year: string, index: number) => {
          return {
            year: year,
            value: data.line[index],
          };
        })
      );
    } catch (e) {}
  };
  const getList = async () => {
    try {
      // https://apiv2.wxstores.cn/screen/Other/getEnergyRanking
      const res = await request.get("/screen/Other/getEnergyRanking");
      const data = res.data.data;
      setList(
        data.map((item: any, index: number) => {
          return {
            label: item.company_name,
            electricity: item.electricity,
            water: item.water,
          };
        })
      );
    } catch (e) {}
  };
  useEffect(() => {
    getDataShui();
  }, [currentYearShui]);
  useEffect(() => {
    getDataDian();
  }, [currentYearDian]);
  useEffect(() => {
    getList();
  }, []);
  return (
    <EnergyConsumptionAnalysisLayout>
      <div className={styles.commonBox}>
        <div className={styles.WisdomPartyBuilding}>
          <LiveTime />
          <MainLayout
            leftWidth={495}
            left={
              <div>
                <div className="warn-content">
                  <div className={classNames(styles.flex, styles.cardTitle)}>
                    <CardTitle
                      titleStyles={{
                        paddingLeft: 65,
                      }}
                      title="能耗预警"
                    />
                  </div>
                  <div className={styles.flex}>
                    <div className="warn-item">
                      <div className={styles.flex}>
                        <div className="warn-val">0</div>
                        <div className="warn-val">0</div>
                      </div>
                      <p>用电预警</p>
                    </div>
                    <div className="warn-item">
                      <div className={styles.flex}>
                        <div className="warn-val">0</div>
                        <div className="warn-val">0</div>
                      </div>
                      <p>用水预警</p>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(styles.flex, styles.cardTitle)}
                  style={{ paddingRight: 30, marginTop: 20 }}
                >
                  <CardTitle title="累计用水量趋势分析" />
                  <YearPicker
                    isRange={true}
                    defaultValues={currentYearShui}
                    onChange={(e, dateStr) => {
                      // @ts-ignore
                      setCurrentYearShui(dateStr);
                    }}
                  />
                </div>
                {shui?.length && (
                  <EchartSingleLine
                    xAxisData={shui.map((item: any) => item.year)}
                    lineData={shui.map((item: any) => item.value)}
                    legendData={["用水"]}
                  />
                )}
                {/* <div className="area-chart">
                      <Area {...config} data={shui} />  
                  </div> */}
                <div
                  className={classNames(styles.flex, styles.cardTitle)}
                  style={{ paddingRight: 30 }}
                >
                  <CardTitle title="累计用电量趋势分析" />
                  <YearPicker
                    isRange={true}
                    defaultValues={currentYearDian}
                    onChange={(e, dateStr) => {
                      // @ts-ignore
                      setCurrentYearDian(dateStr);
                    }}
                  />
                </div>
                {dian?.length && (
                  <EchartSingleLine
                    xAxisData={dian.map((item: any) => item.year)}
                    lineData={dian.map((item: any) => item.value)}
                    legendData={["用电"]}
                  />
                )}
                {/*<div className="area-chart">
                     <Area {...config} data={dian} /> 
                  </div>*/}
              </div>
            }
            rightWidth={507}
            right={
              <div>
                <CardTitle
                  titleStyles={{
                    paddingLeft: 65,
                  }}
                  title="各企业能耗排名"
                />
                <div>
                  <div className={classNames(styles.flex, "points")}>
                    <div className={classNames(styles.flex, "point-item")}>
                      <span>电表</span>
                      <div className="point electricity"></div>
                    </div>
                    <div className={classNames(styles.flex, "point-item")}>
                      <span>水表</span>
                      <div className="point water"></div>
                    </div>
                  </div>
                  <div className="energy" style={{ height: 700 }}>
                    <Swiper
                      slidesPerView={18}
                      spaceBetween={0}
                      autoplay={{
                        delay: 2000,
                        // disableOnInteraction: false,
                      }}
                      loop={false}
                      pagination={{
                        clickable: true,
                      }}
                      onActiveIndexChange={(swiper) => {
                        console.log(swiper.realIndex);
                      }}
                      // navigation={true}
                      direction={"vertical"}
                      modules={[Autoplay]}
                      // modules={[Pagination, Navigation]}
                      //   className="mySwiper"
                    >
                      {list.map((item: any, index) => {
                        return (
                          <SwiperSlide>
                            {" "}
                            <li key={index} className={styles.flex}>
                              <div className={styles.flex1}>{item.label}</div>
                              <div className="point-box" style={{ width: 100 }}>
                                <div
                                  className="electricity point"
                                  style={{ width: item.electricity }}
                                ></div>
                                <div
                                  className="water point"
                                  style={{ width: item.water }}
                                ></div>
                              </div>
                            </li>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                    {/* {list.map((item: any, index) => {
                      return (
                        <li key={index} className={styles.flex}>
                          <div className={styles.flex1}>{item.label}</div>
                          <div className="point-box" style={{ width: 100 }}>
                            <div
                              className="electricity point"
                              style={{ width: item.electricity }}
                            ></div>
                            <div
                              className="water point"
                              style={{ width: item.water }}
                            ></div>
                          </div>
                        </li>
                      );
                    })} */}
                  </div>
                </div>
              </div>
            }
            map={<TMapComp isFullScreen />}
          ></MainLayout>
        </div>
      </div>
    </EnergyConsumptionAnalysisLayout>
  );
};

export default EnergyConsumptionAnalysis;
